import { Injectable } from '@angular/core';
import TONY_STARK from "./info";
import {CookieService} from 'angular2-cookie/services/cookies.service';

@Injectable()
export class ContactInfoService {

  contactInfo = {
    // firstName: TONY_STARK.firstName,
    // lastName: TONY_STARK.lastName,
    // phone: TONY_STARK.phone,
    // website: TONY_STARK.website,
    // company: TONY_STARK.company,
    // email: TONY_STARK.email,
    // marketing: TONY_STARK.marketing,

    firstName: CookieService.prototype.get('firstName'),
    lastName: CookieService.prototype.get('lastName'),
    phone: CookieService.prototype.get('phone'),
    website: CookieService.prototype.get('website'),
    company: CookieService.prototype.get('company'),
    email: CookieService.prototype.get('email'),
    marketing: CookieService.prototype.get('marketing'),

    marketingItems: 'yes no'.split(' ')
  };

  freeEmailProviders = [];

  getContactInfo() {
    return this.contactInfo
  }

  getFreeEmailProviders() {
    fetch('https://api.github.com/gists/5992856')
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (data.files && data.files['free_email_provider_domains.txt'] && data.files['free_email_provider_domains.txt'].content) {
        this.freeEmailProviders = data.files['free_email_provider_domains.txt'].content.split("\n");
        this.freeEmailProviders.push('smart.com');
      }
    });
  }

  constructor() {
    this.getFreeEmailProviders();
  }

}



// WEBPACK FOOTER //
// /app/src/app/Services/contact-info/contact-info.service.ts